import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../../../libs'
import { MultiCount } from './types'
import { $params } from '../../../../../../features/router'

export const multiCountMounted = createEvent()

export const getMultiCount = fx<void, MultiCount | null>({
  method: 'GET',
  url: `/nova/installment/multi_count/`,
})

export const $multiCount = restore<MultiCount | null>(
  getMultiCount.doneData.map((a) => a.body),
  null,
)

sample({
  clock: multiCountMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.clientID
    }

    const query = {
      where: JSON.stringify({ userId: id }),
    }

    return {
      url: `/nova/installment/multi_count`,
      query,
    }
  },
  target: getMultiCount,
})
